import script from "./WalkthroughCelebration.vue?vue&type=script&setup=true&lang=ts"
export * from "./WalkthroughCelebration.vue?vue&type=script&setup=true&lang=ts"

import "./WalkthroughCelebration.vue?vue&type=style&index=0&id=3bff93f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bff93f0"]])

export default __exports__